import { useEffect, useLayoutEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Button, Card, Col, DatePicker, Form, Icon, Row, Select, Switch, Table, Tooltip, Typography } from 'antd'
import { isEqual, sample } from 'lodash'
import moment from 'moment'

import Star from '../../assets/images/Star.svg'
import AtentionIcon from '../../assets/images/atentionIcon.svg'
import Clockicon from '../../assets/images/clockIcon.svg'
import { ReactComponent as Conquista } from '../../assets/images/dashboard/Contorno.svg'
import FarmerIcon from '../../assets/images/farmerIcon.svg'
import FarmerIconWhite from '../../assets/images/farmerIconWhite.svg'
import EmptyData from '../../assets/images/ico_dashboard.svg'
import PositionIcon from '../../assets/images/icone.svg'
import QuestionIcon from '../../assets/images/questionIcon.svg'
import RoofIcon from '../../assets/images/roofIcon.svg'
import RoofBlackIcon from '../../assets/images/roofIconBlack.svg'
import RoofIconWhite from '../../assets/images/roofIconWhite.svg'
import SucessIcon from '../../assets/images/sucessIcon.svg'
import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomSelect from '../../components/CustomSelect/customSelect'
import SelectOrganization from '../../components/SelectOrganization/SelectOrganization'
import { RULES, validRule } from '../../constants/Entitlements'
import { getMessage } from '../../util/IntlMessages'
import { api, request } from '../../util/handlerRequestUtil'
import { isAdmin, isRtv } from '../../util/profiles'
import { EibDashboard } from './EibDashboard'
import { EmptyDashboard } from './EmptyDashboard'
import chartColors from './chart-colors'
import { renderChart, stackedBarChart, treeMapChart } from './chart-props'
import './styles.css'
const { RangePicker } = DatePicker
const dateFormat = 'DD-MM-YYYY'

moment.updateLocale(moment.locale('pt-br'), { invalidDate: '-' })

const DashboardTypes = {
  FARMERS_AND_ACTIONS: 0,
  EIB: 1
}

const { Option } = Select
const BY_ELECTS_CHART_TYPE = 1
const BY_AREA_CHART_TYPE = 2
const CHART_SHOW_DISTRICTS = 'CHART_SHOW_DISTRICTS'
const CHART_SHOW_CUSTOMERS = 'CHART_SHOW_CUSTOMERS'
const CHART_SHOW_CUSTOMER_INFO = 'CHART_SHOW_CUSTOMER_INFO'
const CHART_BY_QUESTION = 'CHART_BY_QUESTION'

function formatData(item) {
  return {
    value: item.value,
    description: item.description
  }
}

const Filters = ({
  values,
  errors = {},
  setFieldValueWithState,
  formatedDistricts,
  formatedCustomerTypes,
  formatedLocationTypes,
  handleClickFilter,
  handleClickClearFilter,
  setFieldValueWithFields,
  loggedUser
}) => {
  const compState = {
    advancedFilter: false,
    districtsWithFilter: []
  }
  const [state, setState] = useState(compState)
  const [customerList, setCustomerList] = useState([])
  const [customerListAll, setCustomerListAll] = useState([])
  const [dataPickerSelected, setDataPickerSelected] = useState(false)
  const [formatedActionFields, setFormatedActionFields] = useState([])
  const [formatedFieldAnswers, setFormatedFieldAnswers] = useState([])
  const [formattedRegions, setFormattedRegions] = useState([])
  const [timeOptions, setTimeOptions] = useState([])
  const [actionTypesList, setActionTypesList] = useState([])

  const currentUser = useSelector((state) => state.auth.auth)
  const isCurrentUserAdmin = isAdmin()

  useEffect(() => {
    if (!isCurrentUserAdmin) {
      getRegions(currentUser.organizationId, true)
    }
  }, [])

  useEffect(() => {
    fetchHarvests()
    getListActionTypes()
  }, [])

  const getListActionTypes = async () => {
    try {
      const items = await request(api.getActionTypesDropdown({ active: true }))
      const formatedData = items.map(formatData)
      setActionTypesList(formatedData)
    } catch (error) {
      console.error({ error })
    }
  }

  async function fetchHarvests() {
    const items = await request(api.listSafra({ active: true }))

    const formattedValues = items.map((item) => ({
      value: item.id,
      description: item.name,
      initialDate: moment(item.referencePeriodRanges[0].beginDate, 'YYYY-MM-DD').format('DD-MM-YYYY'),
      endDate: moment(item.referencePeriodRanges[0].endDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
    }))

    setTimeOptions([...formattedValues, { value: 1, description: 1 }])
  }

  async function onChangeOrganization(field, value) {
    setFieldValueWithFields({
      organization: value,
      dashboardFilterDistrict: [],
      dashboardFilterRegional: [],
      dashboardFilterCustomer: []
    })

    await getRegions(value)
  }

  const getRegions = async (organizationId) => {
    try {
      const params = { active: true }

      if (organizationId) {
        params.organizationId = organizationId
      }

      let items = await request(api.listRegionDropDown(params))

      setFormattedRegions(items)
    } catch (error) {
      console.error({ error })
    }
  }

  async function onChangeRegion(field) {
    if (field && field.length === 0) {
      // Nao tem regional selecionada vou limpar distrito e agricultores
      setFieldValueWithFields({
        dashboardFilterDistrict: [],
        dashboardFilterRegional: [],
        dashboardFilterCustomer: []
      })
      setCustomerList([])
      return
    }

    const districtsToBeSelected = formatedDistricts.filter((district) => field.includes(district.regionId))
    let districtsValid = values.dashboardFilterDistrict ? values.dashboardFilterDistrict : []
    if (Array.isArray(districtsValid) && districtsValid.length > 0) {
      const districts = formatedDistricts.filter((district) => values.dashboardFilterDistrict.includes(district.value))
      districtsValid = districts
        .filter((district) => field.includes(district.regionId))
        .map((district) => district.value)
      if (!isEqual(districtsValid, values.dashboardFilterDistrict)) {
        setFieldValueWithFields({
          dashboardFilterDistrict: districtsValid,
          dashboardFilterRegional: field
        })
      }
    }

    if (districtsToBeSelected.length === 1) {
      districtsValid = [districtsToBeSelected[0].value]
      setFieldValueWithFields({
        dashboardFilterDistrict: [districtsToBeSelected[0].value],
        dashboardFilterRegional: field
      })
    }

    setState({
      ...state,
      districtsWithFilter: districtsToBeSelected
    })
    getElected(null, field, districtsValid)
  }

  async function getFieldsByActionType(actionTypeId) {
    try {
      const [fields] = await request(api.getFormsById({ id: actionTypeId }))
      const formatedData = fields.formFields.map((item) => {
        return {
          value: item.internalFieldName,
          description: item.fieldName,
          internalFieldName: item.internalFieldName,
          fieldProperties: item.fieldProperties
        }
      })

      setFormatedActionFields(formatedData)
    } catch (error) {
      console.error({ error })
    }
  }

  async function getElected(name, regionList, districtList, customerTypeList, locationTypeList) {
    // Caso customerType esteja selecionado vou incluir no filtro
    let customerType = []
    if (customerTypeList) {
      customerType = customerTypeList
    } else if (values.menuNameCustomerTypes && values.menuNameCustomerTypes.length > 0) {
      customerType = values.menuNameCustomerTypes
    }

    // Caso locationType esteja selecionado vou incluir no filtro
    let locationType = []
    if (locationTypeList) {
      locationType = locationTypeList
    } else if (values.classificationElectedLocal && values.classificationElectedLocal.length > 0) {
      locationType = values.classificationElectedLocal
    }

    if (regionList && regionList.length > 0) {
      let regionsWithotDistrict = regionList
      // So envio a regional se a mesma nao tiver distrito selecionado
      if (districtList.length > 0) {
        const regionListToUse = regionList.length > 0 ? regionList : values.dashboardFilterRegional
        const districts = formatedDistricts.filter((district) => districtList.includes(district.value))
        regionsWithotDistrict = regionListToUse.filter(
          (regionId) => !districts.map((district) => district.regionId).includes(regionId)
        )
      }

      let customers = []

      if (regionsWithotDistrict.length) {
        customers = await request(api.getCustomersDropdown({ regionId: regionsWithotDistrict }))
      } else if (districtList.length) {
        customers = await request(api.getCustomersDropdown({ districtId: districtList }))
      }

      const formatedData = customers.map((item) => {
        return {
          value: item.value,
          description: item.description.slice(0, 25)
        }
      })

      // Removendo os agricultores que foram selecionados e nao fazem mais parte do filtro
      if (values.dashboardFilterCustomer && values.dashboardFilterCustomer.length > 0) {
        const mapedCustomerArray = customers.map((customer) => customer.id)
        const validCustomers = values.dashboardFilterCustomer.filter((customerId) =>
          mapedCustomerArray.includes(customerId)
        )
        const newState = {
          dashboardFilterDistrict: districtList,
          dashboardFilterRegional: regionList,
          dashboardFilterCustomer: validCustomers,
          classificationElectedLocal: locationType,
          menuNameCustomerTypes: customerType
        }
        setFieldValueWithFields(newState)
      }

      setCustomerList(formatedData)
      setCustomerListAll(formatedData)
    } else if (name) {
      if (name.length === 3) {
        try {
          const customers = await request(api.getCustomersDropdown())
          const formatedData = customers.map((item) => {
            return {
              value: item.value,
              description: item.description.slice(0, 25)
            }
          })
          setCustomerList(formatedData)
        } catch (error) {
          console.error({ error })
        }
      }

      if (name.length > 3 && customerListAll.length > 0) {
        const formatedData = []
        customerListAll.map((item) => {
          if (item.description.includes(name)) {
            formatedData.push(item)
          }
        })
        setCustomerList(formatedData)
      }
    }
  }

  async function onChangeDistrict(field) {
    if (isRtv(loggedUser)) {
      const newState = {
        dashboardFilterDistrict: [],
        dashboardFilterRegional: [],
        dashboardFilterCustomer: [],
        classificationElectedLocal: [],
        menuNameCustomerTypes: []
      }
      setFieldValueWithFields(newState)
      setCustomerList([])
      setCustomerListAll([])
      return
    }

    getElected(null, values.dashboardFilterRegional, field)
  }

  async function onChangeCustomerType(field) {
    const listOfRegions = values.dashboardFilterRegional ? values.dashboardFilterRegional : []
    const listOfDistricts = values.dashboardFilterDistrict ? values.dashboardFilterDistrict : []
    getElected(null, listOfRegions, listOfDistricts, field)
  }

  async function onChangeLocationType(field) {
    const listOfRegions = values.dashboardFilterRegional ? values.dashboardFilterRegional : []
    const listOfDistricts = values.dashboardFilterDistrict ? values.dashboardFilterDistrict : []
    getElected(null, listOfRegions, listOfDistricts, null, field)
  }

  async function onChangeVisitType(field) {
    getFieldsByActionType(field)
    const newState = {
      questionAddressed: null,
      responseObtain: null,
      dashboardFilterActionType: [field]
    }
    setFieldValueWithFields(newState)
    setFormatedFieldAnswers([])
  }

  async function onChangeActionFields(field) {
    const selectedQuestion = formatedActionFields.find((item) => item.internalFieldName === field)
    const fieldProperties = JSON.parse(selectedQuestion.fieldProperties)
    let newFormatedFieldAnswers = []
    if (fieldProperties && Array.isArray(fieldProperties.options)) {
      newFormatedFieldAnswers = fieldProperties.options
    }

    setFormatedFieldAnswers(newFormatedFieldAnswers)
  }

  function onChangePeriod(values, interval) {
    const periods = []
    const safraIds = []

    if (values.includes(1)) {
      return (
        interval &&
        setFieldValueWithFields({
          periods: [
            {
              initialDate: interval[0],
              endDate: interval[1]
            }
          ]
        })
      )
    }

    timeOptions.map(({ value, initialDate, endDate }) => {
      if (values.includes(value)) {
        safraIds.push(value)
        periods.push({ initialDate, endDate })
      }
    })

    if (values.length) {
      setTimeOptions(timeOptions.filter((obj) => obj.description !== 1))
    } else {
      setTimeOptions([...timeOptions, { value: 1, description: 1 }])
    }

    setFieldValueWithFields({ safraIds, periods })
  }

  function renderPeriodFilter({ span = 6 }) {
    return (
      <Col span={span}>
        <Typography>
          {getMessage('timeCourse')}
          <span className="required-asterisk"> *</span>
        </Typography>
        {dataPickerSelected ? (
          <div style={{ display: 'flex' }}>
            <RangePicker
              separator={'-'}
              placeholder={['Data Inicial', 'Data Final']}
              style={{
                marginTop: 8,
                border: '0px solid none',
                backgroundColor: 'transparent'
              }}
              format={dateFormat}
              onChange={(e, values) => {
                onChangePeriod([1], values)
              }}
            />
            <Button
              icon="close"
              type="ghost"
              style={{
                marginTop: 8,
                width: 30,
                marginLeft: 5
              }}
              onClick={() => setDataPickerSelected(false)}
            />
          </div>
        ) : (
          <Select
            placeholder={getMessage('select')}
            mode="multiple"
            onChange={(value) => {
              if (value !== 1) {
                onChangePeriod(value)
              } else {
                setDataPickerSelected(false)
              }
            }}
            style={{ width: '100%', marginTop: 7 }}
          >
            {timeOptions.map((status) =>
              status.description !== 1 ? (
                <Option value={status.value} key={status.value}>
                  {status.description}
                </Option>
              ) : (
                <Option
                  value={status.value}
                  key={status.value}
                  onClick={() => setDataPickerSelected(!dataPickerSelected)}
                >
                  Personalizado
                </Option>
              )
            )}
          </Select>
        )}
      </Col>
    )
  }

  function renderOrganizationFilter({ span = 6 }) {
    return (
      <SelectOrganization
        errors={errors}
        field="organization"
        setFieldValue={setFieldValueWithState}
        formValues={values}
        rowSpan={span}
        onChangeWithField={onChangeOrganization}
        required
      />
    )
  }

  function basicFilters() {
    const rowSpan = isCurrentUserAdmin ? 4 : 6

    return (
      <>
        <Row type="flex" justify="start">
          {renderPeriodFilter({ span: rowSpan })}
          {renderOrganizationFilter({ span: rowSpan })}
          <CustomSelect
            showSearch
            enable={isCurrentUserAdmin && !values.organization}
            multiple
            field="dashboardFilterRegional"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={formattedRegions}
            onChange={onChangeRegion}
            required
          />
          <CustomSelect
            showSearch
            enable={!values.dashboardFilterRegional || values.dashboardFilterRegional.length === 0}
            multiple
            field="dashboardFilterDistrict"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            onChange={onChangeDistrict}
            values={state.districtsWithFilter}
          />
          <CustomSelect
            showSearch
            multiple
            field="dashboardFilterCustomer"
            label={getMessage('listCustomer')}
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={customerList}
          />
        </Row>
      </>
    )
  }

  function advancedFilters() {
    const rowSpan = isCurrentUserAdmin ? 6 : 8

    return (
      <>
        <Row type="flex" justify="start">
          {renderPeriodFilter({ span: rowSpan })}
          {renderOrganizationFilter({ span: rowSpan })}
          <CustomSelect
            showSearch
            enable={isCurrentUserAdmin && !values.organization}
            multiple
            field="dashboardFilterRegional"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={formattedRegions}
            onChange={onChangeRegion}
          />
          <CustomSelect
            showSearch
            enable={!values.dashboardFilterRegional || values.dashboardFilterRegional.length === 0}
            multiple
            field="dashboardFilterDistrict"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            onChange={onChangeDistrict}
            values={state.districtsWithFilter}
          />
        </Row>
        <Row type="flex" justify="start">
          <CustomSelect
            showSearch
            multiple
            field="menuNameCustomerTypes"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={formatedCustomerTypes}
            onChange={onChangeCustomerType}
          />
          <CustomSelect
            showSearch
            multiple
            field="classificationElectedLocal"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={formatedLocationTypes}
            onChange={onChangeLocationType}
          />
          <CustomSelect
            showSearch
            multiple
            field="dashboardFilterCustomer"
            label={getMessage('listCustomer')}
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={customerList}
          />
        </Row>
        <Row type="flex" justify="start">
          <CustomSelect
            showSearch
            field="dashboardFilterActionType"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={actionTypesList}
            onChange={onChangeVisitType}
          />
          <CustomSelect
            showSearch
            field="questionAddressed"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={formatedActionFields}
            onChange={onChangeActionFields}
          />
          <CustomSelect
            showSearch
            field="responseObtain"
            errors={errors}
            setFieldValue={setFieldValueWithState}
            rowSpan={rowSpan}
            value={values}
            values={formatedFieldAnswers}
          />
        </Row>
      </>
    )
  }

  return (
    <>
      {state.advancedFilter ? advancedFilters() : basicFilters()}
      <div className="horizontal-line" style={{ margin: '20px 0px 20px' }}></div>
      <Row type="flex" justify="start">
        <Col span={14}>
          <div style={style.filterButtonContainer}>
            <Typography style={{ marginRight: 10 }}>{getMessage('advancedFilter')}</Typography>
            <Switch
              onChange={() => {
                // Se estiver indo para filtro basico vou limpar os avancados
                if (state.advancedFilter) {
                  setFieldValueWithFields({
                    menuNameCustomerTypes: [],
                    dashboardFilterActionType: [],
                    classificationElectedLocal: [],
                    questionAddressed: [],
                    responseObtain: []
                  })
                  // Recarregando customers
                  const listOfRegions = values.dashboardFilterRegional ? values.dashboardFilterRegional : []
                  const listOfDistricts = values.dashboardFilterDistrict ? values.dashboardFilterDistrict : []
                  // Aqui tenhoq ue passar customerTypeList, locationTypeList como []
                  // pq quero forcar que nao entrem no filtro do customer
                  getElected(null, listOfRegions, listOfDistricts, [], [])
                }

                setState({
                  ...state,
                  advancedFilter: !state.advancedFilter
                })
              }}
            />
          </div>
        </Col>
        <Col span={5}>
          <Button
            icon="search"
            className="bgPrimary"
            style={{ width: '100%' }}
            type="dashed"
            onClick={handleClickFilter}
            disabled={values.dashboardFilterRegional > 0 ? false : true}
          >
            {getMessage('search')}
          </Button>
        </Col>
        <Col span={5}>
          <Button
            icon="close"
            style={{
              width: '100%',
              borderColor: '#EE778F',
              color: '#EE778F'
            }}
            type="ghost"
            onClick={handleClickClearFilter}
          >
            {getMessage('cleanFilters')}
          </Button>
        </Col>
      </Row>
    </>
  )
}

const RepresentativeResults = ({ chartData }) => {
  const [representativeChartViewType, setRepresentativeChartViewType] = useState(BY_ELECTS_CHART_TYPE)
  const [colorByAnswer, setColorByAnswer] = useState({})
  let renderTreeMapChart = null
  const { itemCurrent } = chartData
  let farmerButtonStyle = style.farmerButton
  let roofButtonStyle = style.roofButton
  let expandedRowRender = null
  let tableFormatedData = []
  let chartFormatedData = []
  let rowClassNameFunction = ''
  let shouldUpdateColorByAnswer = false

  if (itemCurrent.chartType === CHART_SHOW_DISTRICTS) {
    if (representativeChartViewType === BY_ELECTS_CHART_TYPE) {
      farmerButtonStyle = style.farmerButtonSelected
      chartData.data = chartData.data.map((item) => {
        return {
          ...item,
          y: item.electQuant
        }
      })
    } else {
      roofButtonStyle = style.roofButtonSelected
      chartData.data = chartData.data.map((item) => {
        return {
          ...item,
          y: item.area
        }
      })
    }

    if (chartData.data.length > 0) {
      renderTreeMapChart = treeMapChart(chartData.data)
      tableFormatedData = chartData.data
    }
  } else if (itemCurrent.chartType === CHART_SHOW_CUSTOMERS) {
    if (chartData.data.length > 0) {
      renderTreeMapChart = treeMapChart(chartData.data.slice(0, 20))
      tableFormatedData = chartData.data
    }
  } else if (itemCurrent.chartType === CHART_BY_QUESTION) {
    if (chartData.data.length > 0) {
      const reducedData = chartData.data.reduce(function (r, a) {
        r[a.answer] = r[a.answer] || []
        r[a.answer].push(a)
        return r
      }, Object.create(null))
      const newColorByAnswer = colorByAnswer
      tableFormatedData = Object.keys(reducedData).map((item) => {
        let customers = 0
        let areaTotal = 0
        let currenteColor = ''
        for (const element of reducedData[item]) {
          customers += parseInt(element.electQuant)
          areaTotal += parseFloat(element.area)
        }

        if (!colorByAnswer[item]) {
          shouldUpdateColorByAnswer = true
          const arrayColorHex = Object.keys(colorByAnswer).map((answer) => colorByAnswer[answer].hex)
          colorByAnswer[item] = sample(
            chartColors.filter((chartColorItem) => !arrayColorHex.includes(chartColorItem.hex))
          )
        }

        currenteColor = colorByAnswer[item]
        return {
          customerCount: customers,
          area: areaTotal,
          subItems: reducedData[item],
          x: item,
          color: currenteColor
        }
      })
      chartFormatedData = chartData.data.map((item) => {
        const color = colorByAnswer[item.answer]
        const strLabel = `${item.district}(${item.answer})`
        return {
          ...item,
          x: strLabel,
          color
        }
      })

      expandedRowRender = (currentItem) => {
        const columns = [
          { title: 'district', dataIndex: 'district', key: 'district' },
          { title: 'electQuant', dataIndex: 'electQuant', key: 'electQuant' },
          { title: 'Area', dataIndex: 'area', key: 'area' }
        ]

        return <Table showHeader={false} columns={columns} dataSource={currentItem.subItems} pagination={false} />
      }

      const chartOptions = {
        colors: chartFormatedData.map((item) => item.color.hex),
        plotOptions: {
          treemap: {
            enableShades: false,
            shadeIntensity: 0.5,
            reverseNegativeShade: true,
            distributed: true,
            useFillColorAsStroke: false
          }
        }
      }
      rowClassNameFunction = (record) => {
        return `table-row-color${record.color.id}`
      }

      renderTreeMapChart = treeMapChart(chartFormatedData.slice(0, 20), chartOptions)
      if (shouldUpdateColorByAnswer) {
        setColorByAnswer(newColorByAnswer)
      }
    }
  }

  function getColumns() {
    if (chartData.itemCurrent.chartType === CHART_SHOW_DISTRICTS) {
      return [
        {
          title: getMessage('district'),
          dataIndex: 'x',
          width: 40,
          render: (text) => <Tooltip title={text}>{text.length >= 18 ? `${text.slice(0, 19)}...` : text}</Tooltip>
        },
        {
          title: getMessage('totalOfCustomers'),
          dataIndex: 'electQuant',
          width: 30
        },
        {
          title: getMessage('areaPlantedHa'),
          dataIndex: 'area',
          width: 40,
          render: (value) => <p>{parseFloat(value).toLocaleString('pt-BR')} ha</p>
        }
      ]
    }

    if (chartData.itemCurrent.chartType === CHART_SHOW_CUSTOMERS) {
      return [
        {
          title: () => <p style={{ flexWrap: 'wrap' }}>{getMessage('customer')}</p>,
          dataIndex: 'x',
          width: 55,
          render: (text) => <Tooltip title={text}>{text.length >= 18 ? `${text.slice(0, 19)}...` : text}</Tooltip>
        },
        {
          title: () => <p style={{ flexWrap: 'wrap' }}>{getMessage('menuNameCustomerTypes')}</p>,
          dataIndex: 'types',
          width: 35
        },
        {
          title: () => <p style={{ flexWrap: 'wrap' }}>{getMessage('areaPlantedHa')}</p>,
          dataIndex: 'area',
          width: 40,
          render: (value) => <p>{parseFloat(value).toLocaleString('pt-BR')} ha</p>
        }
      ]
    }

    if (chartData.itemCurrent.chartType === CHART_BY_QUESTION) {
      return [
        {
          title: getMessage('answers'),
          dataIndex: 'x',
          width: 50,
          render: (text) => <p>{text.length >= 18 ? `${text.slice(0, 19)}...` : text}</p>
        },
        {
          title: getMessage('totalCustomers'),
          dataIndex: 'customerCount',
          width: 70
        },
        {
          title: getMessage('areaPlantedHa'),
          dataIndex: 'area',
          width: 70,
          render: (value) => <p>{parseFloat(value).toLocaleString('pt-BR')} ha</p>
        }
      ]
    }
  }

  function getSummary() {
    let formatedArea = 0
    if (itemCurrent.area && parseFloat(itemCurrent.area) > 0) {
      formatedArea = parseFloat(itemCurrent.area).toLocaleString('pt-BR')
    }

    if (chartData.itemCurrent.chartType === CHART_SHOW_DISTRICTS) {
      return (
        <Row type="flex" style={{ marginLeft: -13 }}>
          <Col span={8}>{itemCurrent.name}</Col>
          <Col span={7} style={{ marginLeft: 13 }}>
            {itemCurrent.totalEletects}
          </Col>
          <Col span={4}>{`${formatedArea} ha`}</Col>
        </Row>
      )
    }

    if (chartData.itemCurrent.chartType === CHART_SHOW_CUSTOMERS) {
      return (
        <Row type="flex" style={{ marginLeft: -13 }}>
          <Col span={10}>{itemCurrent.name}</Col>
          <Col span={6} style={{ marginLeft: 13 }}></Col>
          <Col span={4}>{`${formatedArea} ha`}</Col>
        </Row>
      )
    }
  }

  function handleClickChartTypeButton(type) {
    setRepresentativeChartViewType(type)
  }

  function showChartTitle() {
    if (chartData.itemCurrent.chartType === CHART_SHOW_DISTRICTS) {
      return (
        <Row type="flex">
          <Col style={{ display: 'flex' }}>
            <Typography.Title level={4} style={{ fontWeight: '500', marginTop: 5 }}>
              {getMessage('represent')}
            </Typography.Title>
            <div style={{ display: 'flex', marginLeft: '30%' }}>
              <Button style={farmerButtonStyle} onClick={() => handleClickChartTypeButton(BY_ELECTS_CHART_TYPE)}>
                <img
                  src={representativeChartViewType === 1 ? FarmerIconWhite : FarmerIcon}
                  alt="FarmIcon"
                  style={{ marginRight: 5, marginTop: 5, paddingLeft: 2, marginLeft: '-8%' }}
                />
                <Typography style={{ color: farmerButtonStyle.color, paddingRight: 20 }}>
                  {getMessage('abrangence')}
                </Typography>
              </Button>
              <Button style={roofButtonStyle} onClick={() => handleClickChartTypeButton(BY_AREA_CHART_TYPE)}>
                <img
                  src={representativeChartViewType === 1 ? RoofIconWhite : RoofIcon}
                  alt="RoofIcon"
                  style={{ marginRight: 5, marginTop: 5, paddingLeft: 2, marginLeft: '-8%' }}
                />
                <Typography style={{ color: roofButtonStyle.color, paddingRight: 20 }}>
                  {getMessage('cobert')}
                </Typography>
              </Button>
            </div>
          </Col>
        </Row>
      )
    }

    if (chartData.itemCurrent.chartType === CHART_SHOW_CUSTOMERS) {
      return (
        <Row type="flex">
          <Col>
            <Typography.Title level={4} style={{ fontWeight: '500', marginTop: 5 }}>
              {getMessage('representByPlantedArea')}
            </Typography.Title>
          </Col>
        </Row>
      )
    }
  }

  function renderView() {
    if (chartData.itemCurrent.chartType === CHART_SHOW_CUSTOMER_INFO) {
      return null
    }

    if (chartData.data.length > 0) {
      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <div>
            {showChartTitle()}
            {renderChart({ chart: renderTreeMapChart })}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div>
              <Table
                style={{ maxWidth: 520 }}
                expandedRowRender={expandedRowRender}
                scroll={{ y: 500 }}
                columns={getColumns()}
                rowClassName={rowClassNameFunction}
                dataSource={tableFormatedData}
                pagination={false}
                footer={() => <>{getSummary()}</>}
              />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly' }}>
        <div>
          <div style={{ display: 'flex' }}>
            <Typography.Title level={4} style={{ fontWeight: '500', marginTop: 5 }}>
              {getMessage('represent')}
            </Typography.Title>
            <div style={{ display: 'flex', marginLeft: '15%', paddingBottom: 20 }}>
              <Button style={{ ...farmerButtonStyle, backgroundColor: '#D6DAE0' }} disabled>
                <img
                  src={representativeChartViewType === 1 ? FarmerIconWhite : FarmerIcon}
                  alt="FarmIcon"
                  style={{ marginRight: 5, marginTop: 5, paddingLeft: 2, marginLeft: '-8%' }}
                />
                <Typography style={{ color: '#fff', paddingRight: 20 }}>{getMessage('abrangence')}</Typography>
              </Button>
              <Button disabled style={roofButtonStyle}>
                <img
                  src={representativeChartViewType === 1 ? RoofIconWhite : RoofIcon}
                  alt="RoofIcon"
                  style={{ marginRight: 5, marginTop: 5, paddingLeft: 2, marginLeft: '-8%' }}
                />
                <Typography style={{ color: roofButtonStyle.color, paddingRight: 20 }}>
                  {getMessage('cobert')}
                </Typography>
              </Button>
            </div>
          </div>
          <div style={{ display: 'grid', placeItems: 'center', width: 510, height: 510, background: '#F1F3F5' }} />
        </div>
        <div style={{ display: 'grid', placeItems: 'center', padding: 135, background: '#F1F3F5' }}>
          <img src={EmptyData} alt="FarmIcon" />
          <Typography
            style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 18, marginTop: -72 }}
          >
            {'Sem dados'}
          </Typography>
          <Typography
            style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -107 }}
          >
            {'Aplique ou altere o filtro para'}
          </Typography>
          <Typography
            style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -180 }}
          >
            {'exibir dados.'}
          </Typography>
        </div>
      </div>
    )
  }

  return <>{renderView()}</>
}

const ElectedResults = ({ chartData }) => {
  const [selectedMember, setSelectedMember] = useState('')
  let electedResult = null
  if (chartData.itemCurrent.chartType === CHART_SHOW_CUSTOMER_INFO) {
    if (chartData.data.length > 0) {
      let electedInfo = chartData.data[0]
      if (selectedMember !== '') {
        electedInfo = chartData.data.find((item) => item.responsible[0] === selectedMember)
      }

      const membersList = chartData.data.map((item) => item.responsible[0])
      const meberListOptions = membersList.map((responsible) => (
        <Option key={responsible} value={responsible}>
          {responsible}
        </Option>
      ))
      electedResult = (
        <div style={{ marginLeft: 25, marginRight: 25 }}>
          <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <div style={{ display: 'flex', marginTop: 10 }}>
              <div
                style={{
                  width: 50,
                  marginTop: -6,
                  height: 50,
                  marginRight: 5,
                  borderRadius: 50,
                  backgroundColor: '#843EF7'
                }}
              >
                <Typography style={{ color: '#fff', fontSize: 20, marginLeft: 10, paddingTop: 12 }}>
                  {electedInfo.customerName.slice(0, 2).toLocaleUpperCase()}
                </Typography>
              </div>
              <Typography style={{ color: '#334863', fontSize: 18, marginLeft: 12, paddingTop: 7 }}>
                {electedInfo.customerName}
              </Typography>
            </div>
            <div style={{ marginLeft: 15 }}>
              <Typography>{getMessage('owner')}</Typography>
              <Select
                value={electedInfo.responsible[0].slice(0)}
                onChange={(value) => {
                  setSelectedMember(value)
                }}
                disabled={membersList.length < 2}
                style={{ width: '100%', marginTop: 7 }}
              >
                {meberListOptions}
              </Select>
            </div>
            <div>
              <Typography>{getMessage('report_district')}</Typography>
              <Select value={electedInfo.district[0]} disabled={true} style={{ width: '100%', marginTop: 7 }} />
            </div>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 60 }} />
              <img src={Star} alt="StarIcon" width={27} style={{ margin: 5 }} />
              <div style={{ marginTop: 17 }}>
                <Typography style={{ color: '#8591A1', fontWeight: '500' }}>{getMessage('customerType')}</Typography>
                <Typography style={{ color: '#334863', fontWeight: '500' }}>{electedInfo.type}</Typography>
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 60 }} />
              <img src={PositionIcon} alt="FarmIcon" width={27} style={{ margin: 5 }} />
              <div style={{ marginTop: 17 }}>
                <Typography style={{ color: '#8591A1', fontWeight: '500' }}>{getMessage('classification')}</Typography>
                <Typography style={{ color: '#334863', fontWeight: '500' }}>{electedInfo.classification}</Typography>
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 60 }} />
              <img src={RoofBlackIcon} alt="FarmIcon" width={27} style={{ margin: 5 }} />
              <div style={{ marginTop: 17 }}>
                <Typography style={{ color: '#8591A1', fontWeight: '500', width: 190 }}>
                  {getMessage('totalAreaNacional')}
                </Typography>
                <Typography style={{ color: '#334863', fontWeight: '500' }}>{`${parseFloat(
                  electedInfo.totalArea
                ).toLocaleString('pt-BR')} ha`}</Typography>
              </div>
            </div>
          </div>
          <div className="horizontal-line" style={{ marginTop: '3%' }} />
          <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: 30 }}>
            <Card style={{ width: 250 }}>
              <Typography
                style={{ color: '#334863', fontWeight: '500', width: 200, textAlign: 'center' }}
              >{`${getMessage('areaPlanted')} ${electedInfo.district[0]} (ha)`}</Typography>
              <div className="horizontal-line" style={{ marginTop: '3%' }} />
              <Typography
                style={{
                  color: '#334863',
                  fontWeight: 'bold',
                  fontSize: 20,
                  width: 190,
                  textAlign: 'center',
                  marginTop: 30
                }}
              >{`${parseFloat(electedInfo.areaPlanted).toLocaleString('pt-BR')} ha`}</Typography>
            </Card>
            <Card style={{ width: 280 }}>
              <Typography
                style={{ color: '#334863', fontWeight: '500', width: 200, textAlign: 'center' }}
              >{`${getMessage('representative')} ${electedInfo.district[0]}`}</Typography>
              <div className="horizontal-line" style={{ marginTop: '3%' }} />
              <div style={{ display: 'flex', marginTop: '4%', marginBottom: -10 }}>
                <Typography
                  style={{ color: '#334863', fontWeight: 'bold', fontSize: 20, marginTop: 20, marginLeft: -10 }}
                >{`${electedInfo.representativeDistrict.percent}%`}</Typography>
                <div
                  className="line-vertical"
                  style={{ height: 60, marginTop: 10, marginLeft: 10, marginRight: 10, paddingBottom: -10 }}
                />
                <div>
                  <Row type="flex" style={{ marginTop: 17 }}>
                    <Typography
                      style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}
                    >{`${electedInfo.representativeDistrict.percentClassification}%`}</Typography>
                    <Typography
                      style={{ color: '#8591A1', fontWeight: '500', fontSize: 11, marginLeft: 3, marginRight: 3 }}
                    >
                      {'em'}
                    </Typography>
                    <Typography style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}>
                      {electedInfo.classification}
                    </Typography>
                  </Row>
                  <div className="horizontal-line" style={{ marginTop: '3%', width: 115 }} />
                  <Row type="flex" style={{ marginTop: 5, width: 190 }}>
                    <Typography
                      style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}
                    >{`${electedInfo.representativeDistrict.percentType}%`}</Typography>
                    <Typography
                      style={{ color: '#8591A1', fontWeight: '500', fontSize: 11, marginLeft: 3, marginRight: 3 }}
                    >
                      {'em'}
                    </Typography>
                    <Typography style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}>
                      {electedInfo.type}
                    </Typography>
                  </Row>
                </div>
              </div>
            </Card>
            <Card style={{ width: 280 }}>
              <Typography style={{ color: '#334863', fontWeight: '500', width: 250, textAlign: 'center' }}>
                {'Representatividade em ' + electedInfo.region}
              </Typography>
              <div className="horizontal-line" style={{ marginTop: '3%' }} />
              <div style={{ display: 'flex', marginTop: '4%', marginBottom: -10 }}>
                <Typography
                  style={{ color: '#334863', fontWeight: 'bold', fontSize: 20, marginTop: 20 }}
                >{`${electedInfo.representativeRegion.percent}%`}</Typography>
                <div className="line-vertical" style={{ height: 60, marginTop: 10, marginLeft: 10, marginRight: 10 }} />
                <div>
                  <Row type="flex" style={{ marginTop: 17 }}>
                    <Typography
                      style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}
                    >{`${electedInfo.representativeRegion.percentClassification}%`}</Typography>
                    <Typography
                      style={{ color: '#8591A1', fontWeight: '500', fontSize: 11, marginLeft: 3, marginRight: 3 }}
                    >
                      {'em'}
                    </Typography>
                    <Typography style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}>
                      {electedInfo.classification}
                    </Typography>
                  </Row>
                  <div className="horizontal-line" style={{ marginTop: '3%', width: 115 }} />
                  <Row type="flex" style={{ marginTop: 5, width: 190 }}>
                    <Typography
                      style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}
                    >{`${electedInfo.representativeRegion.percentType}%`}</Typography>
                    <Typography
                      style={{ color: '#8591A1', fontWeight: '500', fontSize: 11, marginLeft: 3, marginRight: 3 }}
                    >
                      {'em'}
                    </Typography>
                    <Typography style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}>
                      {electedInfo.type}
                    </Typography>
                  </Row>
                </div>
              </div>
            </Card>
            <Card style={{ width: 280 }}>
              <Typography style={{ color: '#334863', fontWeight: '500', width: 250, textAlign: 'center' }}>
                {'Representatividade Nacional'}
              </Typography>
              <div className="horizontal-line" style={{ marginTop: '3%' }} />
              <div style={{ display: 'flex', marginTop: '4%', marginBottom: -10 }}>
                <Typography
                  style={{ color: '#334863', fontWeight: 'bold', fontSize: 20, marginTop: 20 }}
                >{`${electedInfo.representativeNacional.percent}%`}</Typography>
                <div className="line-vertical" style={{ height: 60, marginTop: 10, marginLeft: 10, marginRight: 10 }} />
                <div>
                  <Row type="flex" style={{ marginTop: 17 }}>
                    <Typography
                      style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}
                    >{`${electedInfo.representativeNacional.percentClassification}%`}</Typography>
                    <Typography
                      style={{ color: '#8591A1', fontWeight: '500', fontSize: 11, marginLeft: 3, marginRight: 3 }}
                    >
                      {'em'}
                    </Typography>
                    <Typography style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}>
                      {electedInfo.classification}
                    </Typography>
                  </Row>
                  <div className="horizontal-line" style={{ marginTop: '3%', width: 115 }} />
                  <Row type="flex" style={{ marginTop: 5, width: 190 }}>
                    <Typography
                      style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}
                    >{`${electedInfo.representativeNacional.percentType}%`}</Typography>
                    <Typography
                      style={{ color: '#8591A1', fontWeight: '500', fontSize: 11, marginLeft: 3, marginRight: 3 }}
                    >
                      {'em'}
                    </Typography>
                    <Typography style={{ color: '#334863', fontWeight: '500', fontSize: 11 }}>
                      {electedInfo.type}
                    </Typography>
                  </Row>
                </div>
              </div>
            </Card>
          </div>
        </div>
      )
    } else {
      electedResult = (
        <div style={{ display: 'grid', placeItems: 'center', padding: 14, background: '#F1F3F5' }}>
          <img src={EmptyData} alt="FarmIcon" />
          <Typography
            style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 18, marginTop: 10 }}
          >
            {'Sem dados'}
          </Typography>
          <Typography style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: 15 }}>
            {'Aplique ou altere o filtro para'}
          </Typography>
          <Typography style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18 }}>
            {'exibir dados.'}
          </Typography>
        </div>
      )
    }
  }

  return electedResult
}

function actionsResults(actionsTotal) {
  let actions = null
  if (actionsTotal !== 0) {
    actions = (
      <div style={{ marginTop: -20, display: 'grid', placeItems: 'center', padding: 14, width: 295 }}>
        <Typography style={{ color: '#334863', fontWeight: '500', textAlign: 'center', fontSize: 20 }}>
          {getMessage('totalActions')}
        </Typography>
        <div className="horizontal-line" style={{ marginTop: '14%', width: '100%' }} />
        <Typography style={{ color: '#334863', fontWeight: 'bold', fontSize: 29, textAlign: 'center', marginTop: 20 }}>
          {actionsTotal}
        </Typography>
      </div>
    )
  } else {
    actions = (
      <div style={{ display: 'grid', placeItems: 'center', padding: 14, background: '#F1F3F5' }}>
        <img src={EmptyData} alt="FarmIcon" />
        <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 18, marginTop: 10 }}>
          {'Sem dados'}
        </Typography>
        <Typography style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: 15 }}>
          {'Aplique ou altere o filtro para'}
        </Typography>
        <Typography style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18 }}>
          {'exibir dados.'}
        </Typography>
      </div>
    )
  }

  return actions
}

function actionsProportionResults(actionsData) {
  const finishedPercent = parseFloat(actionsData.finished.percent).toLocaleString('pt-BR')
  const unplannedPercent = parseFloat(actionsData.unplanned.percent).toLocaleString('pt-BR')
  const planedPercent = parseFloat(actionsData.planed.percent).toLocaleString('pt-BR')
  const latePercent = parseFloat(actionsData.late.percent).toLocaleString('pt-BR')
  const actionsValues = [
    {
      data: [finishedPercent]
    },
    {
      data: [unplannedPercent]
    },
    {
      data: [planedPercent]
    },
    {
      data: [latePercent]
    }
  ]
  const renderstackedChart = stackedBarChart(actionsValues)
  let percetCahrt = null
  if (
    actionsValues[0].data !== 0 ||
    actionsValues[1].data !== 0 ||
    actionsValues[2].data !== 0 ||
    actionsValues[3].data !== 0
  ) {
    const finishedQtd = parseFloat(actionsData.finished.quant).toLocaleString('pt-BR')
    const unplannedQtd = parseFloat(actionsData.unplanned.quant).toLocaleString('pt-BR')
    const planedQtd = parseFloat(actionsData.planed.quant).toLocaleString('pt-BR')
    percetCahrt = (
      <>
        <Row type="flex" justify="start" style={{ justifyContent: 'space-around' }}>
          <Col span={5}>
            <div style={{ display: 'flex' }}>
              <img src={SucessIcon} alt="SucessIcon" width={27} style={{ marginRight: 5 }} />
              <Typography style={{ color: '#04D1D1', fontWeight: '500', marginTop: 7 }}>{'Realizadas: '}</Typography>
              <Typography style={{ color: '#334863', fontWeight: '500', marginTop: 7, marginLeft: 4 }}>
                {finishedQtd}
              </Typography>
              <Typography
                style={{ color: '#8591A1', fontWeight: '500', marginTop: 7, marginLeft: 4 }}
              >{`(${finishedPercent}%)`}</Typography>
            </div>
          </Col>
          <Col span={6}>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
              <img src={QuestionIcon} alt="QuestionIcon" width={27} style={{ marginRight: 5 }} />
              <Typography style={{ color: '#FFB40B', fontWeight: '500', marginTop: 7 }}>
                {'Não Planejadas: '}
              </Typography>
              <Typography style={{ color: '#334863', fontWeight: '500', marginTop: 7, marginLeft: 4 }}>
                {unplannedQtd}
              </Typography>
              <Typography
                style={{ color: '#8591A1', fontWeight: '500', marginTop: 7, marginLeft: 4 }}
              >{`(${unplannedPercent}%)`}</Typography>
            </div>
          </Col>
          <Col span={5}>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
              <img src={Clockicon} alt="Clockicon" width={27} style={{ marginRight: 5 }} />
              <Typography style={{ color: '#369EFF', fontWeight: '500', marginTop: 7 }}>{'Planejadas: '}</Typography>
              <Typography style={{ color: '#334863', fontWeight: '500', marginTop: 7, marginLeft: 4 }}>
                {planedQtd}
              </Typography>
              <Typography
                style={{ color: '#8591A1', fontWeight: '500', marginTop: 7, marginLeft: 4 }}
              >{`(${planedPercent}%)`}</Typography>
            </div>
          </Col>
          <Col span={5}>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
              <img src={AtentionIcon} alt="AtentionIcon" width={27} style={{ marginRight: 5 }} />
              <Typography style={{ color: '#E21D45', fontWeight: '500', marginTop: 7 }}>{'Atrasadas: '}</Typography>
              <Typography style={{ color: '#334863', fontWeight: '500', marginTop: 7, marginLeft: 4 }}>
                {actionsData.late.quant}
              </Typography>
              <Typography
                style={{ color: '#8591A1', fontWeight: '500', marginTop: 7, marginLeft: 4 }}
              >{`(${latePercent}%)`}</Typography>
            </div>
          </Col>
        </Row>
        <div className="horizontal-line" style={{ marginTop: '3%', width: '100%' }} />
        <div style={{ marginLeft: -30, marginTop: -15, marginBottom: -30, textAlign: '-webkit-center' }}>
          {renderChart({ chart: renderstackedChart })}
        </div>
      </>
    )
  } else {
    percetCahrt = (
      <>
        <Row type="flex" justify="start" style={{ justifyContent: 'space-between' }}>
          <Col span={5}>
            <div style={{ display: 'flex' }}>
              <img src={SucessIcon} alt="SucessIcon" width={27} style={{ marginRight: 5 }} />
              <Typography style={{ color: '#334863', fontWeight: '500', marginTop: 7 }}>{'Realizadas: '}</Typography>
            </div>
          </Col>
          <Col span={6}>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
              <img src={QuestionIcon} alt="QuestionIcon" width={27} style={{ marginRight: 5 }} />
              <Typography style={{ color: '#334863', fontWeight: '500', marginTop: 7 }}>
                {'Não Planejadas: '}
              </Typography>
            </div>
          </Col>
          <Col span={5}>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
              <img src={Clockicon} alt="Clockicon" width={27} style={{ marginRight: 5 }} />
              <Typography style={{ color: '#334863', fontWeight: '500', marginTop: 7 }}>{'Planejadas: '}</Typography>
            </div>
          </Col>
          <Col span={5}>
            <div style={{ display: 'flex' }}>
              <div className="line-vertical" style={{ height: 30, marginLeft: -15, marginRight: 15 }} />
              <img src={AtentionIcon} alt="AtentionIcon" width={27} style={{ marginRight: 5 }} />
              <Typography style={{ color: '#334863', fontWeight: '500', marginTop: 7 }}>{'Atrasadas: '}</Typography>
            </div>
          </Col>
        </Row>
        <div className="horizontal-line" style={{ marginTop: '3%', width: '100%' }} />
        <div style={{ textAlign: '-webkit-center', height: 45, backgroundColor: '#F1F3F5', marginTop: 50 }} />
      </>
    )
  }

  return percetCahrt
}

function Dashboard({ match, history }) {
  const [updateDateTime, setUpdateDatetime] = useState('')
  const [formValues, setFormValues] = useState({})
  const [key, setKeyValue] = useState(0)
  const auth = useSelector((state) => state.auth)
  const [isFiltered, setIsFiltered] = useState(false)
  // Filters
  const [formatedActionTemplate, setFormatedActionTemplate] = useState([])
  const [formatedRegions, setFormatedRegions] = useState([])
  const [formatedLocationTypes, setFormatedLocationTypes] = useState([])
  const [formatedDistricts, setFormatedDistricts] = useState([])
  const [formatedActionTypes, setFormatedActionTypes] = useState([])
  const [formatedCustomerType, setFormatedCustomerType] = useState([])
  const INITIAL_ACTION_RESULT_DATA = {
    actionsCount: 0,
    finished: {
      quant: 0,
      percent: 0
    },
    unplanned: {
      quant: 0,
      percent: 0
    },
    planed: {
      quant: 0,
      percent: 0
    },
    late: {
      quant: 0,
      percent: 0
    }
  }

  const [representativeData, setRepresentativeData] = useState({
    itemCurrent: {
      chartType: ''
    },
    data: []
  })

  const [actionResultData, setActionResultData] = useState({ ...INITIAL_ACTION_RESULT_DATA })

  useLayoutEffect(() => {
    const hasAccess = validRule(RULES.DASHBOARD)
    if (!hasAccess) {
      return history.push('/customer/list')
    }
  }, [])

  useEffect(() => {
    setUpdateDatetime(new Date())
    getRegions()
    getDistricts()
    getActionTemplates()
    getActionTypes()
    getCustomerTypes()
    getLocationTypes()
  }, [])

  useEffect(() => {
    clearFilter()
  }, [key])

  const getActionTemplates = async () => {
    try {
      const items = await request(api.getActionTemplatesDropdown())
      const formatedData = items.map((item) => {
        return {
          value: item.value,
          description: item.description
        }
      })

      setFormatedActionTemplate(formatedData)
    } catch (error) {
      console.error({ error })
    }
  }

  const getRegions = async () => {
    try {
      const items = await request(api.listRegionDropDown({ active: true }))

      setFormatedRegions(items)
    } catch (error) {
      console.error({ error })
    }
  }

  const getDistricts = async () => {
    try {
      const items = await request(api.listDistrict({ active: true }))
      const formatedData = []
      for (const item of items) {
        if (
          !isAdmin() &&
          parseInt(item.id) !== parseInt(auth.auth.memberDistrictId) &&
          auth.auth.memberDistrictId !== null
        ) {
          continue
        }

        formatedData.push({
          value: item.id,
          description: item.name,
          regionId: item.regionId
        })
      }

      setFormatedDistricts(formatedData)
    } catch (error) {
      console.error({ error })
    }
  }

  const getActionTypes = async () => {
    try {
      const items = await request(api.getActionTypesDropdown({ active: true }))
      const formatedData = items.map(formatData)
      setFormatedActionTypes(formatedData)
    } catch (error) {
      console.error({ error })
    }
  }

  async function getCustomerTypes(param) {
    try {
      const response = await request(api.listCustomerTypesDropdown(param))
      const formatedData = []
      response.map((item) => {
        return formatedData.push({
          value: item.value,
          description: item.description
        })
      })

      setFormatedCustomerType(formatedData)
    } catch (error) {
      console.error({ error })
    }
  }

  async function getLocationTypes() {
    try {
      const response = await request(api.listTypes({ active: true }))
      const formatedData = []
      response.map((item) => {
        return formatedData.push({
          value: item.value,
          description: item.description
        })
      })

      setFormatedLocationTypes(formatedData)
    } catch (error) {
      console.error({ error })
    }
  }

  async function getChartFilteredData(params) {
    const {
      regionIds = [],
      districtIds = [],
      customerIds = [],
      locationTypesIds = [],
      actionTypesIds = [],
      inretnalFieldName = '',
      responseObtain = ''
    } = params

    if (regionIds.length > 0 || districtIds.length > 0 || customerIds.length > 0 || locationTypesIds.length > 0) {
      let chartType = 'representative-chart'
      if (customerIds.length === 1) {
        chartType = 'customer-info-chart'
      } else if (districtIds.length > 0 && !inretnalFieldName) {
        chartType = 'customers-chart'
      } else if (inretnalFieldName && (responseObtain === '' || responseObtain === null)) {
        chartType = 'by-question-chart'
      }

      request(api.getDashboardChartsByKey(chartType, params)).then((result) => {
        setRepresentativeData(result)
      })
    }

    if (regionIds.length > 0 || districtIds.length > 0 || actionTypesIds.length > 0) {
      request(api.getDashboardChartsByKey('actions-chart', params)).then((result) => {
        setActionResultData(result)
      })
    } else {
      setActionResultData({ ...INITIAL_ACTION_RESULT_DATA })
    }
  }

  const handleClickFilter = () => {
    if (Object.keys(formValues).length > 0) {
      const params = filterNormalize(formValues)
      if (key === 0) {
        setIsFiltered(true)
        getChartFilteredData(params)
      } else if (key === 1) {
        // forecastHandleFilter(params)
      } else if (key === 2) {
        // eventHandleFilter(params)
      }
    }
  }

  const filterNormalize = (params) => {
    const {
      safraIds = [],
      periods = [],
      dashboardFilterRegional,
      dashboardFilterDistrict = [],
      dashboardFilterJourney,
      dashboardFilterCustomer = [],
      menuNameCustomerTypes = [],
      classificationElectedLocal = [],
      dashboardFilterActionType = [],
      questionAddressed = null,
      responseObtain = null,
      dashboardRefuge = null,
      dashboardReplant = null,
      dashboardTechnology = []
    } = params
    let regionsWithotDistrict = dashboardFilterRegional
    // So envio a regional se a mesma nao tiver distrito selecionado
    if (dashboardFilterDistrict.length > 0) {
      const regionListToUse = dashboardFilterRegional
      const districts = formatedDistricts.filter((district) => dashboardFilterDistrict.includes(district.value))
      regionsWithotDistrict = regionListToUse.filter(
        (regionId) => !districts.map((district) => district.regionId).includes(regionId)
      )
    }

    return {
      safraIds,
      periods,
      regionIds: regionsWithotDistrict,
      districtIds: dashboardFilterDistrict,
      actionTemplateId: dashboardFilterJourney,
      customerIds: dashboardFilterCustomer,
      customerTypesIds: menuNameCustomerTypes,
      locationTypesIds: classificationElectedLocal,
      actionTypesIds: dashboardFilterActionType,
      inretnalFieldName: questionAddressed,
      responseObtain,
      refuge: dashboardRefuge,
      replant: dashboardReplant,
      technology: dashboardTechnology
    }
  }

  const setFieldValueWithState = (field, value) => {
    setFormValues({
      ...formValues,
      [field]: value
    })
  }

  const setFieldValueWithFields = (fields) => {
    setFormValues({
      ...formValues,
      ...fields
    })
  }

  const clearFilter = () => {
    setFormValues({})
  }

  const actionsAndElectDashboard = () => {
    return (
      <>
        <Card className="ant-card gx-card ant-card-bordered">
          <Filters
            values={formValues}
            setFieldValueWithState={setFieldValueWithState}
            formatedActionTemplate={formatedActionTemplate}
            formatedRegions={formatedRegions}
            formatedDistricts={formatedDistricts}
            formatedActionTypes={formatedActionTypes}
            formatedCustomerTypes={formatedCustomerType}
            formatedLocationTypes={formatedLocationTypes}
            handleClickFilter={handleClickFilter}
            handleClickClearFilter={clearFilter}
            setFieldValueWithFields={setFieldValueWithFields}
            loggedUser={auth.auth}
          />
        </Card>

        {isFiltered ? (
          <div style={{ overflow: 'auto', whiteSpace: 'nowrap' }}>
            {/*  Bloco de represntatividde  */}
            <div style={{ display: 'flex' }}>
              <Card className="ant-card gx-crd ant-card-bordered" style={{ width: '300%' }}>
                <div style={{ justifyContent: 'flex-start' }}>
                  <RepresentativeResults chartData={representativeData} values={formValues} />
                </div>
                <div style={{ justifyContent: 'flex-start' }}>
                  <ElectedResults chartData={representativeData} />
                </div>
              </Card>
            </div>

            {/*  Bloco de visitas  */}
            <div style={{ display: 'flex' }}>
              <Card className="ant-card gx-card ant-card-bordered" style={{ width: '100%' }}>
                <div style={{ justifyContent: 'flex-start' }}>{actionsResults(actionResultData.actionsCount)}</div>
              </Card>
              <Card className="ant-card gx-card ant-card-bordered" style={{ marginLeft: 14, width: '300%' }}>
                <div style={{ justifyContent: 'flex-start' }}>{actionsProportionResults(actionResultData)}</div>
              </Card>
            </div>
          </div>
        ) : (
          <EmptyDashboard />
        )}
      </>
    )
  }

  const renderEib = () => <EibDashboard />

  return (
    <section>
      <Form layout="vertical">
        <div style={style.container}>
          <div style={style.breadcrumb}>
            <CustomBreadcrumb match={match} history={history} />
            <div style={{ display: 'flex' }}>
              <Typography style={{ fontSize: 14, color: '#8591A1' }}>{'Dados atualizados em: '}</Typography>
              <Typography style={{ fontSize: 14, color: '#263447' }}>
                {moment(updateDateTime).format('DD/MM/YYYY')}
              </Typography>
              <Typography style={{ fontSize: 14, color: '#8591A1' }}>{' às '}</Typography>
              <Typography style={{ fontSize: 14, color: '#263447' }}>
                {moment(updateDateTime).format('HH:mm')}
              </Typography>
            </div>
          </div>
        </div>

        <Row type="flex" justify="start" style={{ paddingBottom: 30 }}>
          <Col span={4}>
            <Button
              style={{ borderWidth: 0, display: 'flex', backgroundColor: 'transparent' }}
              onClick={() => setKeyValue(DashboardTypes.FARMERS_AND_ACTIONS)}
            >
              <Icon
                type="user"
                style={{
                  color: key === DashboardTypes.FARMERS_AND_ACTIONS ? '#843EF7' : '#8591A1',
                  fontSize: 23,
                  marginRight: 10
                }}
              />
              <Typography
                style={{
                  color: key === DashboardTypes.FARMERS_AND_ACTIONS ? '#843EF7' : '#8591A1',
                  fontWeight: '500',
                  fontSize: 14
                }}
              >
                {'Visitas e Agricultores'}
              </Typography>
            </Button>
            <div
              className="horizontal-line"
              style={{
                borderWidth: 3,
                marginLeft: 7,
                borderColor: key === DashboardTypes.FARMERS_AND_ACTIONS ? '#843EF7' : '#8591A1',
                width: 150
              }}
            />
          </Col>

          <Col span={4}>
            <Button
              style={{ borderWidth: 0, display: 'flex', backgroundColor: 'transparent' }}
              onClick={() => setKeyValue(DashboardTypes.EIB)}
            >
              <span
                style={{
                  fontSize: 20,
                  marginRight: 10
                }}
              >
                <Conquista fill={'#FFF'} stroke={key === DashboardTypes.EIB ? '#843EF7' : '#8591A1'} />
              </span>
              <Typography
                style={{ color: key === DashboardTypes.EIB ? '#843EF7' : '#8591A1', fontWeight: '500', fontSize: 14 }}
              >
                {'EIB'}
              </Typography>
            </Button>
            <div
              className="horizontal-line"
              style={{
                borderWidth: 3,
                marginLeft: 7,
                borderColor: key === DashboardTypes.EIB ? '#843EF7' : '#8591A1',
                width: 150
              }}
            />
          </Col>
        </Row>
        {key === 0 && actionsAndElectDashboard()}

        {key === 1 && renderEib()}
      </Form>
    </section>
  )
}

const style = {
  container: {
    paddingBottom: '0.5rem'
  },
  breadcrumb: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    alignItems: 'center'
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    alignItems: 'center'
  },
  typography: {
    margin: '0'
  },
  filterButton: {
    width: '5rem'
  },
  filterButtonContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  chart: {
    border: '2px solid #eee',
    borderRadius: '10px',
    width: '100%',
    padding: '1rem',
    minHeight: '100%',
    margin: '1rem'
  },
  roofButtonSelected: {
    display: 'flex',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    width: '50%',
    marginLeft: -15,
    paddingLeft: 26,
    borderColor: '#334863',
    color: '#fff',
    backgroundColor: '#334863'
  },
  roofButton: {
    display: 'flex',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    width: '55%',
    marginLeft: -15,
    paddingLeft: 26,
    borderColor: '#334863',
    color: '#8591A1'
  },
  farmerButton: {
    display: 'flex',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    width: '55%',
    borderColor: '#334863',
    color: '#8591A1'
  },
  farmerButtonSelected: {
    display: 'flex',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    width: '50%',
    borderColor: '#334863',
    color: '#fff',
    backgroundColor: '#334863'
  }
}

export default Dashboard
